import { defineMessages } from 'react-intl';

export default defineMessages({
    year: {
        id: 'ml.common.component.MLSelectPolicyToPay.year',
        defaultMessage: 'year'
    },
    halfYear: {
        id: 'ml.common.component.MLSelectPolicyToPay.half year',
        defaultMessage: 'half year'
    },
    active: {
        id: 'ml.common.component.MLSelectPolicyToPay.Active',
        defaultMessage: 'Active'
    },
    cancelled: {
        id: 'ml.common.component.MLSelectPolicyToPay.Cancelled',
        defaultMessage: 'Cancelled'
    },
    renewed: {
        id: 'ml.common.component.MLSelectPolicyToPay.Renewed',
        defaultMessage: 'Renewed'
    },
    sixMonths: {
        id: 'ml.common.component.MLSelectPolicyToPay.6 months',
        defaultMessage: '6 months'
    },
    amountDue: {
        id: 'ml.common.component.MLSelectPolicyToPay.Amount Due: amount',
        defaultMessage: 'Amount Due: {amountDue}'
    },
    autoPolicy: {
        id: 'ml.common.component.MLSelectPolicyToPay.Auto Policy',
        defaultMessage: 'Auto Policy'
    },
    coverageLimitExcessLiability: {
        id: 'ml.common.component.MLSelectPolicyToPay.Coverage Limit Excess Liability',
        defaultMessage: '{coverageLimit} Excess Liability'
    },
    effectiveDate: {
        id: 'ml.common.component.MLSelectPolicyToPay.Effective Date: date',
        defaultMessage: 'Effective Date: {effectiveDate}'
    },
    expirationDate: {
        id: 'ml.common.component.MLSelectPolicyToPay.Expiration Date: date',
        defaultMessage: 'Expiration Date: {expirationDate}'
    },
    feeDetails: {
        id: 'ml.common.component.MLSelectPolicyToPay.Fee Details',
        defaultMessage: 'Fee Details'
    },
    homePolicy: {
        id: 'ml.common.component.MLSelectPolicyToPay.Home Policy',
        defaultMessage: 'Home Policy'
    },
    namedNonOwner: {
        id: 'ml.common.component.MLSelectPolicyToPay.Named Non-Owner',
        defaultMessage: 'Named Non-Owner'
    },
    numberOfVehicles: {
        id: 'ml.common.component.MLSelectPolicyToPay.Number of Vehicles',
        defaultMessage: '{vehiclesNumber} Vehicles'
    },
    policyNumber: {
        id: 'ml.common.component.MLSelectPolicyToPay.PolicyNumber',
        defaultMessage: '#{policyNumber}'
    },
    premiumPerTerm: {
        id: 'ml.common.component.MLSelectPolicyToPay.Premium per term',
        defaultMessage: '{premium}/{term}'
    },
    statusName: {
        id: 'ml.common.component.MLSelectPolicyToPay.Status name',
        defaultMessage: 'Status: {status}'
    },
    umbrellaPolicy: {
        id: 'ml.common.component.MLSelectPolicyToPay.Umbrella Policy',
        defaultMessage: 'Umbrella Policy'
    },
    Vehicle: {
        id: 'ml.common.component.MLSelectPolicyToPay.Vehicle',
        defaultMessage: '1 Vehicle'
    }
});